import React from "react";
import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Typography,
  Divider,
  Tooltip,
  Button,
  TextField,
  Switch,
  TablePagination,
} from "@mui/material";
import { ColorModeContext, useMode } from "../theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { Topbar } from "../layouts/Topbar";
import AuthContext from "../auth/AuthProvider";
import Sidebarr from "../layouts/Sidebar";
import Header from "../components/Header";
import { useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { api } from "../api";
import { fetchToken, fetchRole } from "../auth/Token";
import { FormatedDateAll } from "./AssociationPassbook";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {
  DataGrid,
  GridToolbar,
  GridActionsCellItem,
  GridRowParams,
} from "@mui/x-data-grid";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import MomoAccountComponent from "../components/MomoAccountComponent";
import dayjs from "dayjs";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { CancelOutlined, Delete } from "@mui/icons-material";
import { toast } from 'sonner';

const FormatedDateE = ({ value }) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  const formattedDate = `${year}/${month}/${day}`;
  return <span>{formattedDate}</span>;
};

const MomoAccountForm = ({ cashFlow, association_id }) => {
  const [momo_bal, setMomoSavingsBal] = useState(null);
  const [errors, setErrors] = useState({});
  const { permissions } = useContext(AuthContext);

  const validateInput = () => {
    const newErrors = {};
    if (momo_bal && !/^\d+(\.\d+)?$/.test(momo_bal)) {
      newErrors.momo_bal = "Must be a valid number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  if (permissions && permissions.set_association_momo_bal === true) {
    return (
      <MomoAccountComponent
        cashFlow={cashFlow}
        association_id={association_id}
      />
    );
  } else {
    return null;
  }
};

export const MemberPsbb = ({ params }) => {
  const navigate = useNavigate();
  const handlePsb = () => {
    navigate("/Passbook/", {
      state: {
        Member_id: params.row.member_id,
        Fullname: `${params.row.firstname} ${params.row.lastname}`,
        Psb: params.row.association_members_id,
      },
    });
  };
  return (
    <IconButton onClick={handlePsb}>
      <FileOpenIcon />
    </IconButton>
  );
};

const MomoAccount = () => {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const location = useLocation();
  const association_id = location.state && location.state.association_id;
  const association_name = location.state && location.state.association_name;
  const [todayChecking, setTodayChecking] = useState([]);
  const [todayTransaction, setTodayTransaction] = useState([]);
  const [todayWithdrawals, setTodayWithdrawals] = useState([]);
  const [todayTransfers, setTodayTransfers] = useState([]);
  const [opentodayTransaction, setOpenTodayTransaction] = useState([]);
  const [multiple, setMultiple] = useState(false);
  const [start_date, setStart_date] = useState();
  const [end_date, setEnd_date] = useState();
  const [date, setDate] = useState(dayjs());
  const [no_data, setNo_data] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const currencyFormat = new Intl.NumberFormat("en-GH", {
    style: "currency",
    currency: "GHS",
  });

  const handleFormChange = (event) => {
    setMultiple(event.target.checked);
  };

  const cashFlow = () => {
    setStart_date();
    setEnd_date();
    const data = new FormData();
    data.append("association_id", association_id);
    data.append("date", date);
    data.append("start_date", start_date);
    data.append("end_date", end_date);
    data.append("multiple", multiple);
    api
      .post("/association/cash/view/new/ui", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (response.data === "No data found for this period") {
          setNo_data(response.data);
        } else {
          setNo_data("");
          setTodayChecking(response.data?.all);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const cashFlowForm = (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("association_id", association_id);
    data.append("date", date);
    data.append("start_date", start_date);
    data.append("multiple", multiple);
    data.append("end_date", end_date);
    api
      .post("/association/cash/view/new/ui", data, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        if (response.data === "No data found for this period") {
          setNo_data(response.data);
        } else {
          setNo_data("");
          setTodayChecking(response.data?.all);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleDeleteE = (id) => {
    api
      .delete(`/association/delete/transaction/${id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        cashFlow();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    cashFlow();
  }, [association_id]);

  const handledate = (value) => {
    setStart_date();
    setEnd_date();
    setDate(value);
  };
  useEffect(() => {
    cashFlow();
  }, [date]);

  const Columns = [
    {
      field: "Id",
      headerName: "Id",
      flex: 1,
    },
    {
      field: "Date",
      headerName: "Date",
      flex: 1,
      Width: 50,
    },
    {
      field: "Cash_Bal",
      headerName: "Cash Amount",
      flex: 1,
      renderCell: (params) => (<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.Cash_Bal}</b></Typography>)
    },
    {
      field: "Ecash_Bal",
      headerName: "Momo Amount",
      flex: 1,
      renderCell: (params) => (<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{params.row.Ecash_Bal}</b></Typography>)
    },
    {
      field: "difference",
      headerName: "Difference",
      flex: 1,
    },
    {
      field: "do",
      type: "actions",
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
          icon={<ViewStreamIcon />}
          onClick={handleTodaysTransactions}
          label="Open"
        />,
      ],
    },
  ];

  const [total_dep_cash, setTotal_dep_cash] = useState();

  const handleTodaysTransactions = async () => {
    await api
      .get(`/association/today/everything/${association_id}`, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        setTodayTransaction(response.data?.All_One);
        setTodayWithdrawals(response.data?.Withdrawals);
        setTodayTransfers(response.data?.Transfers);
        setTotal_dep_cash(response.data?.total_dep);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  // console.log(todayTransaction)

  const CustomFooterRowToday = () => {
    return (
      <div>
        <div style={{ display: "flex", padding: "4px" }}>
          <Typography variant="h5" sx={{ color: "red", mr: 4 }}>
            Total:
          </Typography>
          <Typography variant="h5" sx={{ color: "darkblue", mr: 4 }}>
            Credit: {total_dep_cash}{" "}
          </Typography>
        </div>
      </div>
    );
  };


  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const Itemb = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    width: "337px",
    marginBottom: "50px",
    color: theme.palette.text.secondary,
  }));

  const ItemC = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    borderRadius: "17px",
    margin: "10px",
  }));

  const handleSubmit = (formData) => {
    api
      .post("/association/momo/account", formData, {
        headers: {
          Authorization: "Bearer " + fetchToken(),
        },
      })
      .then(function (response) {
        toast.success(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 5 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Header
              title="E-Cash Account"
              subtitle={`${association_name} Cash Reconciliation`}
            />
          </Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Itemb>
                <div style={{ display: "flex" }}>
                  <Typography
                    sx={{ margin: "5px", color: "#003049" }}
                    fontStyle="normal"
                    variant="h6"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Use period</b>
                  </Typography>
                  <Switch
                    checked={multiple}
                    onChange={handleFormChange}
                    sx={{ color: "#001845" }}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                {multiple === true ? (
                  <>
                    <Typography>Filter Date</Typography>
                    <div style={{ display: "flex" }}>
                      {/* onSubmit={transact_sum_form} */}
                      <form onSubmit={cashFlowForm}>
                        <TextField
                          type="date"
                          size="small"
                          required
                          variant="outlined"
                          helperText="From"
                          name="start_date"
                          onChange={(e) => setStart_date(e.target.value)}
                          value={start_date}
                          sx={{ mr: 1 }}
                        />

                        <TextField
                          type="date"
                          size="small"
                          required
                          variant="outlined"
                          helperText="To"
                          name="end_date"
                          onChange={(e) => setEnd_date(e.target.value)}
                          value={end_date}
                          sx={{ mr: 1 }}
                        />

                        <IconButton type="submit">
                          <FilterAltOutlinedIcon />
                        </IconButton>
                        {/* <IconButton onClick={transact_sum}><CancelIcon /></IconButton> */}
                      </form>
                    </div>
                  </>
                ) : (
                  <StaticDatePicker
                    sx={{ width: 125, height: 425 }}
                    value={date}
                    onChange={(new_value) => handledate(new_value)}
                  />
                )}
              </Itemb>
            </Grid>

            <Grid item xs={12} md={8}>
              {no_data === "" ? (
                <ItemC>
                  <Typography
                    sx={{ textAlign: "center" }}
                    variant="subtitle"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>
                      {start_date ? (
                        <>
                          <FormatedDateE value={start_date} /> ~{" "}
                          <FormatedDateE value={end_date} />{" "}
                        </>
                      ) : (
                        <FormatedDateE value={date} />
                      )}
                    </b>
                  </Typography>
                  <Typography
                    sx={{ m: 7, textAlign: "center" }}
                    variant="h2"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>{currencyFormat.format(todayChecking[0]?.Ecash_Bal)}</b>
                  </Typography>
                  <Divider variant="middle" />
                  <Grid container spacing={2} sx={{ m: 7 }}>
                    <Grid item xs={12} md={5}>
                      <div>
                        <Typography
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          variant="h5"
                        >
                          Cash balance:{" "}
                          <b>
                            {currencyFormat.format(todayChecking[0]?.Cash_Bal)}
                          </b>
                        </Typography>
                      </div>
                    </Grid>
                    <Grid item xs={12} md={5}>
                      <div>
                        <Typography
                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          variant="h5"
                        >
                          Difference:{" "}
                          <b>
                            {currencyFormat.format(
                              todayChecking[0]?.Ecash_Bal -
                                todayChecking[0]?.Cash_Bal
                            )}
                          </b>
                        </Typography>
                      </div>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Box
                        sx={{
                          maxWidth: 750,
                          overflowX: "auto",
                          maxHeight: 540,
                          overflowY: "auto",
                          "&::-webkit-scrollbar": {
                            width: "7px",
                          },
                          "&::-webkit-scrollbar-track": {
                            background: "#f1f1f1",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            background: "#888",
                            borderRadius: "10px",
                          },
                          "&::-webkit-scrollbar-thumb:hover": {
                            background: "#555",
                          },
                        }}
                      >
                        <Table
                          sx={{ width: 999 }}
                          size="small"
                          aria-label="a dense table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell align="left">Date</TableCell>
                              <TableCell align="right">Narration</TableCell>
                              <TableCell align="right">Debit</TableCell>
                              <TableCell align="right">Credit</TableCell>
                              <TableCell align="right">Prepared by</TableCell>
                              <TableCell align="right">Balance</TableCell>
                              {/* <TableCell align="right">Open Price</TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {todayChecking[0]?.trn
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              .map((row) => (
                                <TableRow
                                  key={row.transaction_id}
                                  sx={{
                                    "&:last-child td, &:last-child th": {
                                      border: 0,
                                    },
                                    backgroundColor: "#f5f3f4",
                                  }}
                                >
                                  <TableCell align="left">
                                    <FormatedDateAll
                                      value={row.transaction_date}
                                    />
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.narration}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.transaction_type === 2
                                      ? currencyFormat.format(row.amount)
                                      : currencyFormat.format(0)}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.transaction_type === 1
                                      ? currencyFormat.format(row.amount)
                                      : currencyFormat.format(0)}
                                  </TableCell>
                                  <TableCell align="right">
                                    {row.username}
                                  </TableCell>
                                  <TableCell align="right">
                                    {currencyFormat.format(row.balance)}
                                  </TableCell>
                                  {/* <TableCell align="right"><Tooltip title="Modify order">
                                                            {
                                                                row.order_type === "Buy"?
                                                                <IconButton onClick={()=>handleEditOrder(row.order_id)}><BorderColorIcon /></IconButton>
                                                                :<IconButton onClick={()=>handleEditOrderSell(row.order_id)}><BorderColorIcon /></IconButton>
                                                            }
                                                            </Tooltip></TableCell> */}
                                  <TableCell align="right">
                                    <Tooltip title="Cancel order">
                                      <IconButton
                                        onClick={() =>
                                          handleDeleteE(row.transaction_id)
                                        }
                                      >
                                        <Delete />
                                      </IconButton>
                                    </Tooltip>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                        <TablePagination
                          rowsPerPageOptions={[10, 25, 100]}
                          component="div"
                          count={todayChecking[0]?.trn.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={handleChangePage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </ItemC>
              ) : (
                <Typography
                  variant="h4"
                  fontStyle="normal"
                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  sx={{ textAlign: "center" }}
                >
                  <b>{no_data}</b>
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} md={12}>
              <Item>
                <MomoAccountForm
                  cashFlow={cashFlow}
                  onSubmit={handleSubmit}
                  association_id={association_id}
                />
              </Item>
            </Grid>
          </Grid>
        </Box>
      </main>
    </div>
  );
};

export default MomoAccount;
